import Route from '@ember/routing/route';
import { instrumentRoutePerformance } from '@sentry/ember';

class ScansScanIndexRoute extends Route {
  model() {
    return this.modelFor('scans.scan');
  }
}

export default instrumentRoutePerformance(ScansScanIndexRoute);
